import React, { useRef, useState } from "react";
import "./contact.css";
import { AiOutlineMail } from "react-icons/ai";
import { RiMessengerLine } from "react-icons/ri";
import { BsWhatsapp } from "react-icons/bs";
import emailjs from "emailjs-com";
import FlashMessage from "react-flash-message";

const Contact = () => {
  const [loading, setLoading] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const form = useRef();

  const sendEmail = (e) => {
    setLoading(true);
    e.preventDefault();

    emailjs
      .sendForm(
        "service_odfy9kw",
        "template_ubf9wwa",
        form.current,
        "ZgVwd8Bb9eFYmRt9l"
      )
      .then(
        (result) => {
          console.log("result: ", result.text);
          if (result.text == "OK") {
            e.target.reset();
            setShowMessage(true);
            setLoading(false);
          }
        },
        (error) => {
          console.log(error.text);
          setLoading(false);
        }
      );
  };

  return (
    <section id="contact">
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>
      <div className="container content__container">
        <div className="contact__options">
          <article className="contact__option">
            <AiOutlineMail className="contact__icon" />
            <h4>Email</h4>
            <h5>ijazbacha14@gmail.com</h5>
            <a href="mailto:ijazbacha14@gmail.com" target="_blank">
              send a message
            </a>
          </article>

          <article className="contact__option">
            <RiMessengerLine className="contact__icon" />
            <h4>Messenger</h4>
            <h5>Ijaz Bacha</h5>
            <a href="https://m.me/ijaz.ali.5815" target="_blank">
              send a message
            </a>
          </article>

          <article className="contact__option">
            <BsWhatsapp className="contact__icon" />
            <h4>Whatsapp</h4>
            <h5>+923159757691</h5>
            <a
              href="https://api.whatsapp.com/send?phone=+923159757691"
              target="_blank"
            >
              send a message
            </a>
          </article>
        </div>

        {/* END OF CONTACT OPTION */}

        <form className="conatact__form" ref={form} onSubmit={sendEmail}>
          {showMessage && (
            <FlashMessage duration={5000} po>
              <strong>Email successfully sent!</strong>
            </FlashMessage>
          )}
          <input
            type="text"
            name="name"
            placeholder="Your Full Name"
            required
          />
          <input type="email" name="email" placeholder="Your Email" required />
          <textarea
            name="message"
            rows="7"
            placeholder="Your Message"
            required
          ></textarea>
          <button type="submit" className="btn btn-primary">
            {loading ? "Loading..." : "Send Message"}
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
